// absolute link
const feedbackGuidelinesLink = 'https://create.roblox.com/docs/resources/feedback-guidelines';

export default feedbackGuidelinesLink;
